import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
   
  },
  
   {
    path: '/header',
    name: 'headerss',
    component: () => import(/* webpackChunkName: "about" */ '../components/headerss')
  },
  {
    path: '/footer',
    name: 'footerss',
    component: () => import(/* webpackChunkName: "about" */ '../components/footerss')
  },
  {
    path: '/breadcrumb',
    name: 'breadcrumb',
    component: () => import(/* webpackChunkName: "about" */ '../components/breadcrumb')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue')
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import(/* webpackChunkName: "about" */ '../views/Forget.vue')
  },
  {
    path: '/sms',
    name: 'sms',
    component: () => import(/* webpackChunkName: "about" */ '../views/Sms.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import(/* webpackChunkName: "about" */ '../views/User.vue')
  },
  {
    path: '/sign',
    name: 'sign',
    component: () => import(/* webpackChunkName: "about" */ '../views/Sign.vue')
  },
 
]
//线上用hash 测试用 history
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
